import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://tmppnippqvshwwaqyafu.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRtcHBuaXBwcXZzaHd3YXF5YWZ1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODE5NDg1MjYsImV4cCI6MjA5NzUyNDUyNn0.cK4mKYb9xqa6zwjOUdbh9pEFWS__C_Lt843ONe9xwRY'

export const supabase = createClient(supabaseUrl, supabaseKey)